import React from 'react';
import style from './radio-button.module.scss';
import { Option } from './Select'

type Props = {
	selected: string;
	options: Option[]
	onSelect: (value: string) => void
	disabled?: boolean
}

export function RadioButton(props: Props) {
	const { selected, options, onSelect, disabled = false } = props;
	return (
	 <div className={style.radioButton}>
			{options.map(option => {
				return (
					<div data-selected={selected === option.value} className={style.option} key={option.value}>
						<button disabled={disabled} onClick={() => onSelect(option.value)}>
							<span></span>
						</button>
						<p>{option.label}</p>
					</div>
				)
			})}
	 </div>
	);
}
